import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

const Status = () => {
    const [status, setStatus] = useState(false)
    const params = useParams()
    
    useEffect(() => {
        
        
        if (params.slug && params.slug.includes("success")) {
            Swal.fire({
                title: 'Success',
                text: 'Payment successful',
                icon: 'success',
                confirmButtonColor: '#d33',
                customClass: {
                    confirmButton: 'swal2-confirm-red'
                },
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.href = "/event"
            })
        } else if (params.slug && params.slug.includes("failed")) {
            Swal.fire({
                title: 'Failed',
                text: 'Payment failed',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
                customClass: {
                    confirmButton: 'swal2-confirm-red'
                }
            }).then(() => {
                window.location.href = "/event-booking"
            })
        }
    }, [params.slug])

    return (
        <div>
            
        </div>
    )
}

export default Status